var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24623 0.5C3.80393 0.5 1 3.30393 1 6.74623C1 10.1885 3.80393 12.9925 7.24623 12.9925C8.74314 12.9925 10.1179 12.4609 11.1953 11.5785L14.9247 15.308C14.9823 15.3679 15.0512 15.4158 15.1275 15.4487C15.2038 15.4817 15.2859 15.4991 15.369 15.5C15.4521 15.5008 15.5345 15.4851 15.6114 15.4537C15.6884 15.4222 15.7583 15.3758 15.817 15.317C15.8758 15.2583 15.9222 15.1884 15.9537 15.1114C15.9851 15.0345 16.0008 14.9521 16 14.869C15.9991 14.7859 15.9817 14.7038 15.9487 14.6275C15.9158 14.5512 15.8679 14.4823 15.808 14.4247L12.0785 10.6953C12.9609 9.61786 13.4925 8.24314 13.4925 6.74623C13.4925 3.30393 10.6885 0.5 7.24623 0.5ZM7.24623 1.74925C10.0134 1.74925 12.2432 3.97907 12.2432 6.74623C12.2432 9.51338 10.0134 11.7432 7.24623 11.7432C4.47907 11.7432 2.24925 9.51338 2.24925 6.74623C2.24925 3.97907 4.47907 1.74925 7.24623 1.74925Z",
    stroke: "#647D94",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search_icon.38205841bef6746879b49014c846d5f4.svg";